export default "__VITE_ASSET__oUMZK9MQ__"